import React from 'react';
import { WebsiteDesignProps } from './types';
import { Music, Mic2, Piano } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ConservatoryMusic: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Royal Conservatory";

    return (
        <div className="bg-[#0a0a0a] min-h-screen font-serif text-white">
            <nav className="border-b border-white/10 px-12 py-6 flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <Music className="text-amber-400" />
                    <span className="text-xl font-light tracking-wider uppercase">{schoolName}</span>
                </div>
                <div className="hidden md:flex gap-8 text-sm font-sans uppercase tracking-widest text-gray-400">
                    <a href="#" className="hover:text-amber-400 transition-colors">Programs</a>
                    <a href="#" className="hover:text-amber-400 transition-colors">Faculty</a>
                    <a href="#" className="hover:text-amber-400 transition-colors">Concerts</a>
                </div>
                <Button variant="outline" className="border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-black font-sans uppercase text-xs tracking-widest rounded-none">
                    Auditions
                </Button>
            </nav>

            <header className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
                {/* Sound Wave Background */}
                <div className="absolute inset-0 flex items-center justify-center opacity-10">
                    <div className="flex gap-1 items-end h-64">
                        {[...Array(60)].map((_, i) => (
                            <div 
                                key={i} 
                                className="w-1 bg-amber-400 rounded-full animate-pulse"
                                style={{ 
                                    height: `${Math.random() * 100 + 20}%`,
                                    animationDelay: `${i * 0.05}s`
                                }}
                            ></div>
                        ))}
                    </div>
                </div>

                <div className="relative z-10 text-center px-8">
                    <span className="text-amber-400 uppercase tracking-[0.4em] text-xs font-sans mb-6 block">
                        Excellence in Performance
                    </span>
                    <h1 className="text-6xl md:text-8xl font-light mb-8 leading-none">
                        Where Music <br/> <em className="text-amber-400">Lives.</em>
                    </h1>
                    <p className="text-xl text-gray-400 max-w-xl mx-auto mb-12 font-sans font-light">
                        Training virtuosos for the world's greatest stages since 1847.
                    </p>
                    <Button className="bg-amber-400 text-black hover:bg-amber-300 font-sans uppercase tracking-widest text-xs px-12 py-6 rounded-none">
                        Begin Your Journey
                    </Button>
                </div>
            </header>

            <section className="border-t border-white/10 py-20">
                <div className="max-w-6xl mx-auto px-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
                    {[
                        { icon: Piano, title: "Keyboard", count: "42 Faculty" },
                        { icon: Music, title: "Orchestral", count: "68 Faculty" },
                        { icon: Mic2, title: "Voice", count: "24 Faculty" },
                    ].map((item, i) => (
                        <div key={i} className="bg-[#0a0a0a] p-12 text-center hover:bg-white/5 transition-colors">
                            <item.icon className="mx-auto text-amber-400 mb-6" size={40} strokeWidth={1} />
                            <h3 className="text-2xl font-light mb-2">{item.title}</h3>
                            <div className="text-xs font-sans uppercase tracking-widest text-gray-500">{item.count}</div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default ConservatoryMusic;
